module.exports = __webpack_public_path__ + "img/ship.598b6dd7.jpg";